export default class AudioHelper {
  private successAudio;
  private errorAudio;
  private infoAudio;
  private doneAudio;
  private clickAudio;
  public constructor() {
    this.successAudio = new Audio();
    this.successAudio.src = "../assets/sfx/success.mp3";
    this.successAudio.load();
    this.errorAudio = new Audio();
    this.errorAudio.src = "../assets/sfx/error.mp3";
    this.errorAudio.load();
    this.infoAudio = new Audio();
    this.infoAudio.src = "../assets/sfx/info.mp3";
    this.infoAudio.load();
    this.doneAudio = new Audio();
    this.doneAudio.src = "../assets/sfx/done.mp3";
    this.doneAudio.load();
    this.clickAudio = new Audio();
    this.clickAudio.src = "../assets/sfx/click.mp3";
  }
  public playSuccess() {
    this.successAudio.load();
    this.successAudio.play();
  }
  public playError() {
    this.errorAudio.load();
    this.errorAudio.play();
  }
  public playInfo() {
    this.infoAudio.load();
    this.infoAudio.play();
  }
  public playDone() {
    this.doneAudio.load();
    this.doneAudio.play();
  }

  public playClick() {
    this.clickAudio.load();
    this.clickAudio.play();
  }
}
